import { requestServer } from "$lib/servers.svelte";
import { invalidateServerToken } from "$lib/auth.svelte";

export async function describeSeries(server: any, seriesid: string) {
  try {
    const { data, status } = await requestServer(
      server,
      'get',
      `api/v1/series/${seriesid}`,
      null
    )
    if (status == 401) throw { response: { status: 401 } }
    return data
  } catch (error) {
    if (error?.response?.status == 401) {
      invalidateServerToken(server.uid)
      return
    }
    console.log(error)
    return {}
  }
}

export async function progressSeries(server: any, seriesid: string) {
  try {
    const { data, status } = await requestServer(
      server,
      'get',
      `api/v1/progress/${seriesid}`,
      null
    )
    if (status == 401) throw { response: { status: 401 } }
    return data
  } catch (error) {
    if (error?.response?.status == 401) {
      invalidateServerToken(server.uid)
      return
    }
    console.log(error)
    return {}
  }
}

export async function refreshSeriesMetadata(server: any, seriesid: string) {
  try {
    const { data, status } = await requestServer(
      server,
      'post',
      `api/v1/series/${seriesid}/refresh`,
      null
    )
    if (status == 401) throw { response: { status: 401 } }
    return data
  } catch (error) {
    if (error?.response?.status == 401) {
      invalidateServerToken(server.uid)
      return
    }
    console.log(error)
    throw error
  }
}

export async function listSeriesMatches(server: any, seriesid: string, query?: string) {
  try {
    const qs = query?.trim() ? `?q=${encodeURIComponent(query.trim())}` : ''
    const { data, status } = await requestServer(
      server,
      'get',
      `api/v1/series/${seriesid}/matches${qs}`,
      null
    )
    if (status == 401) throw { response: { status: 401 } }
    return data
  } catch (error) {
    if (error?.response?.status == 401) {
      invalidateServerToken(server.uid)
      return
    }
    console.log(error)
    throw error
  }
}

export async function fixSeriesMatch(server: any, seriesid: string, match: any) {
  // Huma rejects null for slice fields; normalize before POST.
  const body = {
    match: {
      ...match,
      altTitles: Array.isArray(match?.altTitles) ? match.altTitles : [],
      staff: Array.isArray(match?.staff) ? match.staff : [],
    },
  }
  try {
    const { data, status } = await requestServer(
      server,
      'post',
      `api/v1/series/${seriesid}/association`,
      body
    )
    if (status == 401) throw { response: { status: 401 } }
    return data
  } catch (error) {
    if (error?.response?.status == 401) {
      invalidateServerToken(server.uid)
      return
    }
    console.log(error)
    throw error
  }
}

export async function unmatchSeries(server: any, seriesid: string) {
  try {
    const { data, status } = await requestServer(
      server,
      'post',
      `api/v1/series/${seriesid}/unmatch`,
      null
    )
    if (status == 401) throw { response: { status: 401 } }
    return data
  } catch (error) {
    if (error?.response?.status == 401) {
      invalidateServerToken(server.uid)
      return
    }
    console.log(error)
    throw error
  }
}

/** English translation of a ranobedb series description (proxied via API → monaid). */
export async function fetchSeriesDescriptionEn(server: any, seriesid: string) {
  try {
    const { data, status } = await requestServer(
      server,
      'get',
      `api/v1/series/${seriesid}/description/en`,
      null
    )
    if (status == 401) throw { response: { status: 401 } }
    return (data?.translation ?? '') as string
  } catch (error) {
    if (error?.response?.status == 401) {
      invalidateServerToken(server.uid)
      return ''
    }
    console.log(error)
    throw error
  }
}
